import request from './index'
import { UserInfo } from '../types'

export const adminApi = {
  getAllUsers: () =>
    request.get<Array<UserInfo>>('/admin/users'),

  resetUserPassword: (userId: number, newPassword: string) =>
    request.post<boolean>(`/admin/users/${userId}/reset-password`, { newPassword }),

  toggleUserStatus: (userId: number, isActive: boolean) =>
    request.post<boolean>(`/admin/users/${userId}/toggle-status`, { isActive }),

  getSystemStats: () =>
    request.get<{ userCount: number; teamCount: number; fragmentCount: number; activeUserCount: number }>('/admin/stats'),
}
